export default "__VITE_ASSET__BvY1qKuI__"